"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgBalanceOutline = function SvgBalanceOutline(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("path", {
    d: 'M2 4c0-1.333.667-2 2-2h16c1.334 0 2 .667 2 2v16c0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2V4zm2 0v16h16V4H4zm4 12h2c.667 0 1 .334 1 1.003 0 .67-.333 1.002-1 .997H8c-.666-.005-1-.34-1-1.004 0-.664.334-.996 1-.996zm6 0h2c.667 0 1 .334 1 1.003 0 .67-.333 1.002-1 .997h-2c-.667-.005-1-.34-1-1.004 0-.664.333-.996 1-.996zm-7.79-5.624c-.064-.64.232-1.255.232-1.255C7.648 7.04 9.505 6 12.012 6c2.509 0 4.366 1.04 5.572 3.12 0 0 .287.575.255 1.195-.022.414-.184.792-.487 1.133l-1.639 1.87a4.591 4.591 0 0 1-.538.492c-.168.127-.49.19-.966.19H9.818c-.497 0-.83-.063-.997-.19a3.29 3.29 0 0 1-.508-.492l-1.64-1.87a1.788 1.788 0 0 1-.464-1.072zm1.99-.145L9.745 12h1.19l.578-2.145c.05-.189.469-.83 1.213-.615.744.215.744.95.713 1.097L13.007 12h1.419l1.424-1.77c-.81-1.448-2.056-2.19-3.738-2.229-1.683-.038-2.987.705-3.912 2.23z'
  }));
};

exports.default = SvgBalanceOutline;